import React, { useState } from "react";
import { Check } from "lucide-react";
import { api } from "../../lib/api";
import { REASON_LABEL } from "../CreditNotePdf";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { toast } from "sonner";

// Motif modifiable tant que l'avoir est en brouillon.
export const CreditNoteReasonEditor = ({ nc, onSaved }) => {
  const [reason, setReason] = useState(nc.reason);
  const [detail, setDetail] = useState(nc.reason_detail || "");
  const [busy, setBusy] = useState(false);
  const dirty = reason !== nc.reason || detail !== (nc.reason_detail || "");
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/credit-notes/${nc.id}`, { reason, reason_detail: detail });
      toast.success("Motif enregistré");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="cn-reason-editor">
      <Select value={reason} onValueChange={setReason}>
        <SelectTrigger data-testid="cn-reason-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {Object.entries(REASON_LABEL).map(([k, v]) => (
            <SelectItem key={k} value={k} data-testid={`cn-reason-${k}`}>{v}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input value={detail} onChange={(e) => setDetail(e.target.value)} placeholder="Précision (ex. accord exceptionnel OSEO, invendus semaine 41)" data-testid="cn-reason-detail" />
      {dirty && (
        <Button size="sm" onClick={save} disabled={busy} className="bg-[#1F4E3D] hover:bg-[#173B2E]" data-testid="cn-reason-save">
          <Check className="w-4 h-4 mr-1" /> Enregistrer le motif
        </Button>
      )}
    </div>
  );
};

export default CreditNoteReasonEditor;
